import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="12" height="11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2.11 5.107L4.43 8.07 9.999 3" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>);